"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MfaPied = void 0;

var _react = _interopRequireWildcard(require("react"));

var _MfaLien = require("./MfaLien");

var _MfaSeparateur = require("./MfaSeparateur");

require("../css/mfa-pied.css");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var MfaPied = /*#__PURE__*/function (_Component) {
  _inherits(MfaPied, _Component);

  var _super = _createSuper(MfaPied);

  function MfaPied() {
    _classCallCheck(this, MfaPied);

    return _super.apply(this, arguments);
  }

  _createClass(MfaPied, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "mfa-pied"
      }, /*#__PURE__*/_react.default.createElement(_MfaSeparateur.MfaSeparateur, {
        espaceDessous: true,
        espaceDessus: true
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "liens"
      }, /*#__PURE__*/_react.default.createElement(_MfaLien.MfaLien, {
        href: "https://www.mfa.gouv.qc.ca/fr/ministere/politique-confidentialite"
      }, "Politique de confidentialit\xE9"), /*#__PURE__*/_react.default.createElement(_MfaLien.MfaLien, {
        href: "https://www.mfa.gouv.qc.ca/fr/ministere/politique-accessibilite"
      }, "Politique d'accessibilit\xE9"), this.props.courriel ? /*#__PURE__*/_react.default.createElement(_MfaLien.MfaLien, {
        href: "mailto:".concat(this.props.courriel)
      }, "Joindre le pilote du syst\xE8me") : null), /*#__PURE__*/_react.default.createElement("div", {
        className: "logo"
      }, /*#__PURE__*/_react.default.createElement(_MfaLien.MfaLien, {
        href: "https://quebec.ca"
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: "data:image/gif;base64,R0lGODlhZQAXAMQAAAwMDuPp8pmZmWZmZgApf8zMzDNmmTMzM5etzf///2mHt+bm5ld6r7O3vAs/jMvV5v4BAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAQUAP8ALAAAAABlABcAAAX/YCKOZGmeaKqubOu+cCzPdLIUTRHU6M6ngYdwKPQliEijqTAAOAEHwWIWkIoWg0PjlzIQvgjEl8AQPRxjhBetQAmcA4H8AC3EFnS7qLnlnrwEDg8NY2VHY4IKY20mbwd6V3SPMFkDU3sAfX4lXgYBYWdkZl8MnwWhjCQFTpojeFAvWJcjfJsmnQphCmiGD18GuQq7BKm0AAMoDawJAgOaDQPIV80HccYNWNGQIkwH1a0JVVnVswloYGKko18OCAyLJa/gJHTITQIjqwfc9VnHmNC8LRPx5pg/fPwMNtkmTJguBQwQiAjQMJiwiCVWAdhWogmyNwhteBNBR9O9BCfD/zU5MEXfpVd2AtAJWaCcrQTKNqbwyAxASDz7lLFcQFQoykwjZPo8aokoln9vpN1EoXGesY9LI+1b6a0rlAC1riaQ1FWgPaRAAqhduzYp27cllEo1MbPnz5EebxTYu/doq6hjferlO6WkijXtxDhw0GvxYneBHBTDxPKE0CkgXeH9dyIsJnx1T4RGAUhQgcWiDrF7sIuNiVdzI2UFLMJoTqueldpZqcRYZdJkPiEI1euLAlOoLMMxAnuEUDuv9h2d5NzvRJ4iOV+BXo/5rE4R3fFaZ4BBATWuLUuKdrCjE0lOpjxVWG16tO751t/vU0B/llnnEBBGIesEAplxKSxAjUVAx5STDTnaODcOOczc981rC1rjSoatQARRGAx8OFFDEZEokQs5aTHViiye0B8cNrUo4yZg0XEMRzPmyEOMOvbo4483hQAAOw==",
        id: "ImagePiedPage",
        alt: "Portail du gouvernement du Qu\xE9bec"
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "droits"
      }, /*#__PURE__*/_react.default.createElement(_MfaLien.MfaLien, {
        href: "http://www.droitauteur.gouv.qc.ca/copyright.php"
      }, "\xA9 Gouvernement du Qu\xE9bec,\xA02020")));
    }
  }]);

  return MfaPied;
}(_react.Component);

exports.MfaPied = MfaPied;